import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_REPORT_MESSAGE } from 'api/notificationManager/methods';

export default class ReportMessageRequest extends WsBaseRequest {
  constructor(data: any) {
    super(API_METHOD_REPORT_MESSAGE, data);
  }
}
